import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Struggle from "@/components/site/Struggle";
import Solution from "@/components/site/Solution";
import Modules from "@/components/site/Modules";
import Preview from "@/components/site/Preview";
import Testimonials from "@/components/site/Testimonials";
import Checkout from "@/components/site/Checkout";
import Faq from "@/components/site/Faq";
import Footer from "@/components/site/Footer";
import MobileCTABar from "@/components/site/MobileCTABar";
import CookieConsent from "@/components/site/CookieConsent";
import DiscountPopup from "@/components/site/DiscountPopup";

export default function Landing() {
  return (
    <div className="relative">
      <Header />
      <main>
        <Hero />
        <Struggle />
        <Solution />
        <Modules />
        <Preview />
        <Testimonials />
        <Checkout />
        <Faq />
      </main>
      <Footer />
      <MobileCTABar />
      <CookieConsent />
      <DiscountPopup />
    </div>
  );
}
